// libs
import React, { memo } from 'react';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';
import { useSelector } from 'react-redux';
import { getWishlistBannerData } from 'shared/store/topBanner/selectors';
import { useWishlistContext } from 'shared/layouts/Wishlist/API/context';

// components
import TopBanner from 'shared/components/TopBanner';

//types
import {
  BANNER_REMOTE_CONFIG_TYPE,
  TopBannerRemoteConfig,
} from 'shared/components/TopBanner/types';

function WishlistTopBanner() {
  const topBannerWidgetData = useSelector(getWishlistBannerData);
  const { wishlist: pageName } = useRemoteConfig('topBanner') as TopBannerRemoteConfig;
  const { isFetching } = useWishlistContext();

  if (!pageName || isFetching) {
    return null;
  }

  return (
    <TopBanner
      pageData={topBannerWidgetData}
      pageType={BANNER_REMOTE_CONFIG_TYPE.Wishlist}
      pageName={pageName}
    />
  );
}

export default memo(WishlistTopBanner);
